// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `rails generate channel` command.

import { createConsumer } from "@rails/actioncable";

class Consumer {
  constructor(jwt) {
    this.consumer = createConsumer(
      jwt ? "/websocket?jwt=" + jwt : "/websocket",
    );
    return this.consumer;
  }
}

export default Consumer;
